import { Button } from "@rio-cloud/rio-uikit";
import { IPositionVehicle, IVehicle } from "@types";

interface Props {
    vehicle?: IVehicle;
    position?: IPositionVehicle;
}

const VehicleDetails = ({vehicle, position}: Props) => {
    return (
        <div className="width-100pct height-100pct">
            <div className="display-flex align-items-center gap-4 padding-top-20 padding-bottom-20">
                <span className="rioglyph rioglyph-truck text-size-h2"></span>
                <span className="text-size-18 text-bold">{vehicle?.name}</span>
            </div>
            <div className="width-100pct height-1 bg-light" >&nbsp;</div>

            {position ? (
                <>
                    {position?.address && (
                        <div className="display-flex flex-column padding-top-15 padding-bottom-15">
                            <span className="text-size-12 text-normal">Posição atual</span>
                            <span className="text-size-16 text-normal">{position?.address}</span>
                        </div>
                    )}
                    <div className="display-flex flex-row align-items-center padding-top-15 padding-bottom-15" style={{ gap: 5 }}>
                        <span className="rioglyph rioglyph-map-marker text-size-20 text-color-primary"></span>
                        <span className="text-size-16 text-normal">{position?.latitude},{position?.longitude}</span>
                    </div>
                    <div className="padding-top-15 padding-bottom-15">
                        <Button className="width-100pct" >Compartilhar posição</Button>
                    </div>
                </>
            ) : (
                <div className="display-flex flex-column padding-top-15 padding-bottom-15">
                    <span className="text-size-12 text-normal">Posição atual</span>
                    <span className="text-size-16 text-normal">Não há posição atual</span>
                </div>
            )}

        </div>
    )
}

export default VehicleDetails;